module.exports = __webpack_public_path__ + "static/wave-f59da55b080f2560dbfb332920fd49cc.png";